import { ISchema, ISchemaProperty } from "../Schema";

const FORM_MEM_PREFIX = 'FORM_MEM_';

export class FormMemory {
    private entityKey: string;

    constructor(private schema: ISchema, entityName?: string) {
        // Use resultsKey if available, otherwise fall back to entityName
        this.entityKey = schema.resultsKey || entityName || 'unknown';
    }

    public persist(data: Record<string, any>) {
        Object.keys(data).forEach(key => {
            const value = data[key];
            const schemaProp = this.schema?.props?.find(x => x.name === key);
            if (schemaProp && schemaProp.rememberLastFormValue) {
                localStorage.setItem(this.remeberedPropertyKey(schemaProp), JSON.stringify(value));
            }
        });
    }

    public resolve() : Record<string, any> {
        const data: Record<string, any> = {};
        for (const value of Object.values(this.schema?.props ?? {})) {
            if (value.rememberLastFormValue) {
                const rememberedValue = localStorage.getItem(this.remeberedPropertyKey(value));
                if (rememberedValue) {
                    data[value.name] = JSON.parse(rememberedValue);
                }
            }
        }
        return data;
    }

    private remeberedPropertyKey(schemaProp: ISchemaProperty) {
        return `${FORM_MEM_PREFIX}${this.entityKey}_${schemaProp.name}`;
    }

    /**
     * Clears all FormMemory items from localStorage.
     * This should be called on login/logout to prevent form values from persisting across user sessions.
     */
    public static clearAll(): void {
        const keysToRemove: string[] = [];
        
        // Iterate through all localStorage keys and find those with FORM_MEM_ prefix
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key && key.startsWith(FORM_MEM_PREFIX)) {
                keysToRemove.push(key);
            }
        }
        
        // Remove all FormMemory keys
        keysToRemove.forEach(key => localStorage.removeItem(key));
    }
}